const apiUrl = process.env.REACT_APP_API_URL;
export const GetControlHorari = async ( page : string, text : string) => {
    try {
        const response = await fetch(`${apiUrl}:8071/controlhorari?usuari=${text}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            }
        });
        const jsonData = await response.json();
        return jsonData;
    } catch (error) {
        console.log('Error al obtener los datos:', error);
    }
};
